var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_vm._v(" This part is not yet ready... Please stay tuned! ")])
}
var staticRenderFns = []

export { render, staticRenderFns }